import { httpClient } from '@/network/clientController'

/** Get Recurring Transfers List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transfers
*/
export const getRecurringTransfersList = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'transfers/recurring',
        params: payload,
		isCancellable: true
	})
}

/** Get Transfers Schedule Types
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transfersscheduleTypes
*/
export const getTransfersScheduleTypes = (payload) => {
    return httpClient({
		method: 'GET',
		url: 'transfers/scheduleTypes',
		params: payload,
		isCancellable: true
	})
}

/** Get Transfers Categories List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transferscategories
*/
export const getTransfersCategoriesList = (payload) => {
    return httpClient({
		method: 'GET',
		url: 'transfers/categories',
		isCancellable: true
	})
}

/** Get Transfers Motives List for a transfer category
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transferscategories%7Bcid%7Dmotives
*/
export const getTransfersMotivesListForTransferCategory = (payload) => {
    return httpClient({
		method: 'GET',
		url: `transfers/categories/${payload}/motives`,
		isCancellable: true
	})
}

/** Get Transfers List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transfers
*/
export const getTransfersList = (payload) => {
    return httpClient({
		method: 'GET',
		url: 'transfers',
        params: payload,
		isCancellable: true
	})
}

/** Creates Pontual Transfer
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_transfers
*/
export const createPontualTransfer = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'transfers',
		data: payload,
		operationTypeId: '74' /* for mocks handling of tokens, still need to fix view payload, to add info for mocks distintion, otherbanks 75 */
	})
}

/** Get Transfers details
@docs
*/
export const getTransfersDetails = (payload) => {
    return httpClient({
		method: 'GET',
		url: `transfers/${payload}`
	})
}

/** Get Transfers type info
@docs https://petstore.swagger.io/ -> explore link: https://app.inm.pt/BAI-MDW-DEV-3G/internet-banking/api/swagger.json -> fazer um find por /info e é o segundo. internet/transfers/type/{id}/info
*/
export const getTransfersTypeInfo = (payload) => {
    return httpClient({
		method: 'GET',
		url: `transfers/type/${payload}/info`
	})
}
